module.exports = cptable;


//////////////////
// WEBPACK FOOTER
// external "cptable"
// module id = 691
// module chunks = 0